import { render, staticRenderFns } from "./jinniuyuanjing.vue?vue&type=template&id=91c57576&scoped=true&"
import script from "./jinniuyuanjing.vue?vue&type=script&lang=js&"
export * from "./jinniuyuanjing.vue?vue&type=script&lang=js&"
import style0 from "./jinniuyuanjing.scss?vue&type=style&index=0&id=91c57576&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91c57576",
  null
  
)

export default component.exports